<template>
  <div>
    <div :class="{copyField: true, dark_mode: $vuetify.theme.dark}"><pre style="overflow-x:auto;padding:5px;">{{ value }}</pre><div v-ripple class="copyValue" @click="copyValue(value)"><span>Copy </span><v-icon>filter_none</v-icon></div></div>
  </div>
</template>
<script>
import { Notifications } from "../../notification";

export default {
  name: "CopyField",
  props: {
    value: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: "The value has been copied into your clipboard."
    }
  },
  methods: {
    copyValue(value){
      event.preventDefault();
      this.$clipboard(value);
      Notifications.show(this.message);
    }
  }
}
</script>
<style scoped>
.copyField {
  overflow-x: auto;
  background: lightgrey;
  padding: 10px;
  border-radius: 10px;
  margin-top:10px;
  margin-bottom: 10px;
}
.copyField.dark_mode {
  background: rgb(61, 61, 61);
}
.copyValue {
  cursor: pointer;
  float: right;
}
</style>
